import jigsawpuzzles from "./jigsawpuzzle";
import sevenWords from "./sevenwords";
import rearrangeSentence from "./rearrangesentence";
import matchingGame from "./matchinggame";
import rateDolphin from "./ratedolphin";
import typingDefense from "./typingdefense";
import typingGame from "./typinggame";

const routeMapTable = {
    jigsawpuzzle: {
        categories: jigsawpuzzles,
        title: "Jigsaw Puzzle"
    },
    sevenwords: {
        categories: sevenWords,
        title: "7 words"
    },
    rearrangesentence: {
        categories: rearrangeSentence,
        title: "Rearrange Sentnce"
    },
    matchinggame: {
        categories: matchingGame,
        title: "Matching Game"
    },
    ratedolphin: {
        categories: rateDolphin,
        title: "Rate Dolphin"
    },
    typingdefense: {
        categories: typingDefense,
        title: "Typing Defense"
    },
    typinggame: {
        categories: typingGame,
        title: "Typing Game"
    }
};

export default routeMapTable;
